import { HeaderCellSort } from "@table-library/react-table-library/sort";
import { styled } from "@vitality-ds/system";
import BaseSortableHeaderCellStyles from "./styles/BaseSortableHeaderCell.styles";

// eslint-disable-next-line import/prefer-default-export
export var SortableHeaderCell = styled(HeaderCellSort, BaseSortableHeaderCellStyles);